import { createEffect } from 'effector'
import ChatAPI from '@api/external/chat'
import { InitialConfig, Thread } from '@loctypes'

type Params = { clientKey: InitialConfig['clientKey']; algorithm?: string }

export const fetchThreadsFx = createEffect(
  (params: Params): Promise<Thread[]> => {
    return ChatAPI.fetchThreads(params.clientKey, params.algorithm)
  }
)
